import React from 'react';
import ReactDatePicker, { registerLocale } from 'react-datepicker';
import cs from 'date-fns/locale/cs';
import { useField } from 'formik';
import moment from 'moment';
import { Button } from '../utils/forms/Button';
import Row from '../Grid/Row';
import Col from '../Grid/Col';

registerLocale('cs', cs);
function DateFieldGroup({ name }) {
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  const [field, , helpers] = useField(name);

  function setTomorrow() {
    helpers.setValue(tomorrow);
  }

  return (
    <Row>
      <Col className="date-field">
        <Button
          type="button"
          size="full"
          onClick={setTomorrow}
          color={
            !moment(tomorrow).isSame(field.value, 'day') ? 'secondary' : ''
          }
        >
          Na zítra
        </Button>
      </Col>
      <Col>
        <ReactDatePicker
          dateFormat="dd.MM.yyyy"
          locale="cs"
          selected={(field.value && new Date(field.value)) || null}
          onChange={(val) => {
            helpers.setValue(val);
          }}
        />
      </Col>
    </Row>
  );
}

export default DateFieldGroup;
